// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"8bf9e361","703":"9b80c3fe","787":"cbebbd04"}[chunkId] + ".chunk.js";
};